import { useCallback, useEffect, useState } from "react";
import { useAppDispatch } from "../../../store";
import { setErrorMessage, setSuccessMessage } from "../../../acions/actionsCreators/messageActions";
import { TASK_WAS_COMPLETED } from "../../../lib/constants";
import { Modal } from "antd";
import BackGroundService from "../../../services/background";

export const useGetTaskStatus = (
  id: string,
  errorMessage: string,
  onSuccess: (id?: string) => void,
  message?: {
    customMsg?: string;
    closable?: boolean;
  },
  onError?: () => void,
  options?: {
    errorMessageClosable?: boolean;
  }
) => {
  const dispatch = useAppDispatch();

  const [percent, setPercent] = useState<number>(0);

  const closeModal = useCallback(
    (success: boolean = true) => {
      Modal.destroyAll();
      success && onSuccess(id);
    },
    [id, onSuccess]
  );

  const showError = useCallback(
    (failedItems: any, msg: string) => {
      const closable = options?.errorMessageClosable ?? false;
      const shouldDisappear = !closable;

      if (failedItems && failedItems.generalErrorMessage) {
        dispatch(setErrorMessage(failedItems.generalErrorMessage[0], shouldDisappear, closable));
      } else {
        dispatch(setErrorMessage(msg, shouldDisappear, closable));
      }
    },
    [dispatch, options]
  );

  const getStatus = useCallback(async () => {
    try {
      const res: any = await BackGroundService.getProgress(id);

      const { progressPercent, status, result, generalExceptionMessage } = res;

      setPercent(progressPercent);

      if ([4, 5, 6].includes(status)) {
        if (status === 4) {
          if (result.failedCount > 0) {
            showError(result.failedItems, errorMessage);
            closeModal(false);
            onError && onError();
          } else {
            setTimeout(() => {
              setPercent(100);

              const msg = message && message.customMsg ? message.customMsg : TASK_WAS_COMPLETED;

              message && dispatch(setSuccessMessage(msg, !!message.closable));

              closeModal();
            }, 500);
          }
        } else if (status === 5) {
          closeModal(false);
          onError && onError();
        } else {
          showError(result.failedItems, generalExceptionMessage);
          closeModal(false);
          onError && onError();
        }
      } else {
        setTimeout(async () => {
          await getStatus();
        }, 3000);
      }
    } catch (e: any) {
      dispatch(setErrorMessage(e.response.data.title, true));
      closeModal(false);
      onError && onError();
    }
  }, [id, showError, errorMessage, closeModal, onError, message, dispatch]);

  useEffect(() => {
    getStatus();
  }, [getStatus]);

  return { percent };
};
